import { render, staticRenderFns } from "./LivesType.vue?vue&type=template&id=165f47ec&"
import script from "./LivesType.vue?vue&type=script&lang=js&"
export * from "./LivesType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports